export const ADD_LIST_VALET_PARKING = 'ADD_LIST_VALET_PARKING';
export const ADD_VALET_PARKING = 'ADD_VALET_PARKING';
export const UPDATE_VALET_PARKING = 'UPDATE_VALET_PARKING';
export const DELETE_VALET_PARKING = 'DELETE_VALET_PARKING';
